import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { ClientWorkspaceLeadType } from './client-workspace-query';

type ClientWorkspaceStateType = Readonly<{ selectedLead: ClientWorkspaceLeadType | null }>;
const initialState: ClientWorkspaceStateType = { selectedLead: null };

export const clientWorkspaceSlice = createSlice({
  name: 'clientWorkspace',
  initialState,
  reducers: {
    setSelectedClientWorkspaceLead: (state, action: PayloadAction<ClientWorkspaceLeadType | null>) => {
      state.selectedLead = action.payload;
    },
  },
});
export const { setSelectedClientWorkspaceLead } = clientWorkspaceSlice.actions;
